import { render, staticRenderFns } from "./z2.vue?vue&type=template&id=799f50a1&scoped=true"
import script from "./z2.vue?vue&type=script&lang=js"
export * from "./z2.vue?vue&type=script&lang=js"
import style0 from "./z2.vue?vue&type=style&index=0&id=799f50a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f50a1",
  null
  
)

export default component.exports